define('models/WidgetGroupCollection',['underscore','ObjectCollection','LocalStorage','models/WidgetGroupModel'],function (_,ObjectCollection,LocalStorage,WidgetGroupModel) {
    //
    // Collection WidgetGroup
    //
    var WidgetGroupCollectionPrototype = {
        
        name:'WidgetGroupCollection',
        route:'apiWidgetGroupCollection',
        model:WidgetGroupModel,
        
        initialize:function(){
            // ObjectCollection constructor heritage
            ObjectCollection.prototype.initialize.apply(this,arguments);
            //
        },

        getAllUrlRewrite:function(onlyUseJS){
            var urlRewrite = [];
            this.each(function(widgetGroup){
                if(onlyUseJS!==true || widgetGroup.get('use_js')){
                    urlRewrite.push(widgetGroup.get('indentifiant'))
                }
            });
            return urlRewrite;
        }
    };

    var WidgetGroupCollection = ObjectCollection.extend(WidgetGroupCollectionPrototype);

    return WidgetGroupCollection;
});
